import {IMAGE_ROOT_DIRECTORY} from "../../config";

const groupIconAndOrder = [{
    name: 'Gebäude',
    icon: 'building_info',
    order: 1,
}, {
    name: 'System aktuell',
    icon: 'heating_current',
    order: 2,
}, {
    name: 'System künftig',
    icon: 'heating_new',
    order: 3,
}]

const groupMapper = (groupName, groupIcon, groupOrder) => {
    const predefined = groupIconAndOrder.find(gi => gi.name === groupName);
    const icon = groupIcon ?? predefined?.icon;
    const order = groupOrder ?? predefined?.order;
    return {
        name: groupName,
        icon: icon ? `${IMAGE_ROOT_DIRECTORY}/group_icons/${icon}.svg` : undefined,
        order,
        entries: [],
    };
}

const groupFromPage = (page) => {
    return groupMapper(
        page.groupName,
        page.groupIcon,   // Not actually available yet but exists as a fallback for future updates
        page.groupOrder,  // Not actually available yet but exists as a fallback for future updates
    );
}

export {groupFromPage, groupMapper};